import { Stack } from "@mui/material";
import { PrimaryFormDateOfBirth } from "react-common-ui-library/FPACT/DateOfBirth";
import { FirstName, LastName } from "react-common-ui-library/FPACT/NameField";
import { SPACING_3_4 } from "../../../Constants/CommonConstants";
import { StyledFormInputsBox, StyledSmallerFieldWrapperBox } from "../../../Styles/Common/CommonStyles";

/**
 * @description Contains first name, last name and date of birth form inputs that are used in name and contact screen.
 * @returns {ReactNode} Render first name, last name and date of birth form inputs imported form common UI library.
 */

const NameAndContactFormInputs = () => {
  return (
    <StyledFormInputsBox>
      <Stack spacing={SPACING_3_4}>
        <FirstName />
        <LastName />
        <StyledSmallerFieldWrapperBox>
          <PrimaryFormDateOfBirth />
        </StyledSmallerFieldWrapperBox>
      </Stack>
    </StyledFormInputsBox>
  );
};

export default NameAndContactFormInputs;
